import styled from 'styled-components';


export const LandingPageWrapper = styled.div`
   overflow-x:hidden;
   width:100%;
`;